"use client";

import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";

const messageKeys = [
  "klarna",
  "hypoallergenic",
  "shippedFromNL",
] as const;

export function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const t = useTranslations("announcement");

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % messageKeys.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const key = messageKeys[index];

  return (
    <div className="bg-foreground text-background py-2.5 overflow-hidden">
      <div className="content-wrapper flex items-center justify-center h-4">
        <AnimatePresence mode="wait">
          <motion.p
            key={index}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="text-xs font-medium tracking-wide text-center text-background"
          >
            {t(key)}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>
  );
}
